// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"SettingSidebar_subHeader__I9faN","newSection":"SettingSidebar_newSection__9PDCQ"};